export default __webpack_public_path__ + "static/media/1980.e77d61d4.png";